var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M30.1 20.6h-8.6v-8.5M22.1 20.2l9-9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M16.4 11.2h-5.2v20.1h20.1v-5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M30.1 20.6h-8.6v-8.5M22.1 20.2l9-9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M16.4 11.2h-5.2v20.1h20.1v-5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.6b652787ed4a9c9beadd8bbb49a629fd.svg";
export { ForwardRef as ReactComponent };